import { FontIcon, IStackStyles, Stack, Text, getTheme, mergeStyleSets, mergeStyles } from "@fluentui/react";
import * as React from "react";
import { useEffect, useState } from "react";

/* globals */

export enum EHintMessageType {
  Info,
  Error,
  Success,
}

interface HintMessageProps {
  message: string;
  type: EHintMessageType;
  styles?: IStackStyles;
}

const theme = getTheme();

const iconClass = mergeStyles({
  fontSize: 35,
  margin: "auto  15px",
});
const coloredIcons = mergeStyleSets({
  blue: [{ color: theme.palette.blue }, iconClass],
  red: [{ color: theme.palette.red }, iconClass],
  greenLight: [{ color: theme.palette.greenLight }, iconClass],
});

export default function HintMessage({ message, type, styles }: HintMessageProps) {
  const [iconColor, setIconColor] = useState<string>();
  const [iconName, setIconName] = useState<string>();

  useEffect(() => {
    switch (type) {
      case EHintMessageType.Info:
        setIconName("AlertSolid");
        setIconColor(coloredIcons.blue);
        break;
      case EHintMessageType.Error:
        setIconName("WarningSolid");
        setIconColor(coloredIcons.red);
        break;
      case EHintMessageType.Success:
        setIconName("CheckMark");
        setIconColor(coloredIcons.greenLight);
        break;
    }
  }, [message, type]);

  return (
    <Stack horizontal styles={styles}>
      <FontIcon iconName={iconName} className={iconColor} />
      <Text>{message}</Text>
    </Stack>
  );
}
